var path = 'ui-formly/directives/serverErrors/index.html';
var html = "<div class=\"text-danger\" ng-if=\"fc.$error.server\"><div class=\"message\">{{fc.serverError}}</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;